import Dayjs from "dayjs";

var localeData = require("dayjs/plugin/localeData");
var localizedFormat = require("dayjs/plugin/localizedFormat");
var relativeTime = require("dayjs/plugin/relativeTime");
var duration = require("dayjs/plugin/duration");
var isSameOrBefore = require("dayjs/plugin/isSameOrBefore");
require("./dayjs-ar-sa");

Dayjs.extend(relativeTime);
Dayjs.extend(localeData);
Dayjs.extend(localizedFormat);
Dayjs.extend(duration);
Dayjs.extend(isSameOrBefore);
Dayjs.locale("ar-sa");

export default Dayjs;
